import React from 'react';
import TransitionFormFields from './TransitionFormFields';
import { transitionSchema } from '../../../lib/transition-schemas';

// ContactedForm — captures channel + contact-person + summary on the
// transition into Contacted. Generic schema-driven renderer; the form-shape
// definition lives in src/lib/transition-schemas.js so the API validator
// reuses it.
export default function ContactedForm({ values, onChange, errors }) {
  return <TransitionFormFields schema={transitionSchema('contacted')} values={values} onChange={onChange} errors={errors} />;
}
